import { render } from "./Status.vue?vue&type=template&id=366e1250&scoped=true"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=366e1250&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-366e1250"

export default script